// extracted by mini-css-extract-plugin
module.exports = {"radio__blue":"CustomRadio_radio__blue__3qAjw","radio_label":"CustomRadio_radio_label__33YqX"};